// src/taskpane/components/ErrorBoundary.tsx
import * as React from "react";
import {
  MessageBar,
  MessageBarBody,
  Button,
} from "@fluentui/react-components";

interface ErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
}

interface ErrorBoundaryProps {
  children: React.ReactNode;
}

export default class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error };
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: "20px" }}>
          <MessageBar intent="error">
            <MessageBarBody>
              <strong>插件发生错误</strong>
              <br />
              {this.state.error?.message}
            </MessageBarBody>
          </MessageBar>
          <Button
            appearance="primary"
            onClick={this.handleReset}
            style={{ marginTop: "10px" }}
          >
            重试
          </Button>
        </div>
      );
    }

    return this.props.children;
  }
}
